<template>
  <div class="app_container">
    <Header></Header>
    <div class="main-box" :class="{'content-collapse':collapse}">
      <transition name="move" mode="out-in">
        <router-view/>
      </transition>
    </div>
    <transition name="fade">
      <div v-show="showBackTop" class="back-top" @click="scrollToTop">
        <i class="el-icon-arrow-up"></i>
      </div>
    </transition>
  </div>
</template>

<script>
import bus from "./bus";
import Header from "./Header";
export default {
  name: "admin",
  components:{
    Header
  },
  data: function () {
    return {
      collapse:'',
      showBackTop: false
    }
  },
  created() {
    bus.$on("collapse", msg => {
      this.collapse = msg;
    });
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showBackTop = (window.pageYOffset || document.documentElement.scrollTop) > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>

<style lang="less" scoped>
.app_container{
  width: 100%;
  height: 100%;
}
.main-box{
  width: 100%;
  background: #FFFFFF;
  &.content-collapse {
    left: 65px;
  }
}
.back-top {
  position: fixed;
  right: 30px;
  bottom: 60px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #409EFF;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 999;
  transition: background 0.3s;
  &:hover {
    background: #66b1ff;
  }
  i {
    font-size: 20px;
    font-weight: bold;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
